const Builder = require('./BuilderBase');

module.exports = class Relation extends Builder {
    constructor(role, properties) {
        super('methodaccess', null, Object.assign({}, { role }, properties));
    }
};
